import ClinicalReviewSubscriptionsPage from "./ClinicalReviewSubscriptionsPage";

export default ClinicalReviewSubscriptionsPage;
